import React from 'react';
import { Navigate } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
import { useAssessment } from '../contexts/AssessmentContext';
export function Submitted() {
  const {
    submitted,
    sessionId,
    participantId
  } = useAssessment();
  if (!submitted) return <Navigate to="/briefing" replace data-id="element-760" data-mp="1flk7qdoq7mqu" />;
  return <main className="flex w-full flex-1 items-center justify-center bg-slate-100 px-6 py-16" data-id="element-761" data-mp="1fmdjxu6gf4gd">
      <div className="w-full max-w-xl rounded-xl border border-slate-200 bg-white p-8" data-id="element-762" data-mp="23cg6xvvihk84">
        <CheckCircle2Icon className="h-7 w-7 text-teal-600" data-id="element-763" data-mp="2896lufvky9ry" />
        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900" data-id="element-764" data-mp="1uagnkwx0y420">
          Your close pack has been submitted
        </h1>
        <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-765" data-mp="1z8i9rqpqyjhp">
          Thank you — that is the end of the session. Nothing further is recorded from this point.
        </p>

        <dl className="mt-6 grid grid-cols-2 gap-4 rounded-lg border border-slate-200 bg-slate-50 p-5" data-id="element-766" data-mp="nuo6ybfxx8jx">
          <div data-id="element-767" data-mp="238394f66rr51">
            <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-768" data-mp="239o3a3ol982d">
              Session ID
            </dt>
            <dd className="mt-1 font-mono-num text-sm text-slate-900" data-id="element-769" data-mp="1yc60yw52tr3c">{sessionId}</dd>
          </div>
          <div data-id="element-770" data-mp="2d4ps0yeyc84f">
            <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-771" data-mp="2889341zxhpqa">
              Participant
            </dt>
            <dd className="mt-1 font-mono-num text-sm text-slate-900" data-id="element-772" data-mp="2m6fsetqtahec">{participantId || '—'}</dd>
          </div>
        </dl>

        <div className="mt-6 space-y-3 text-[14px] leading-relaxed text-slate-600" data-id="element-773" data-mp="2h8e1jmn59dsb">
          <p data-id="element-774" data-mp="2vx0q8eynvhw7">Your record now goes to human review.</p>
          <p data-id="element-775" data-mp="2qyqp7nq99n2o">
            A written account of your performance is available on request — quote your session ID
            above.
          </p>
          <p data-id="element-776" data-mp="34yrr96i9b0jq">
            Questions, corrections, or a request to withdraw your record:{' '}
            <a href="mailto:research@lentic.example" className="font-medium text-slate-900 underline underline-offset-2" data-id="element-777" data-mp="30y7wuap2ib1a">
              research@lentic.example
            </a>
          </p>
        </div>
      </div>
    </main>;
}